
export enum ToolbarMode {
  transparent = 'transparent',
  solid = 'solid',
  both = 'both'
}
export interface FuseConfig
{
  hideToolbar?: boolean;
  toolbarMode?: ToolbarMode;
}
